import React from 'react';
import PropTypes from 'prop-types';

export const Logout = ({ width , height , ...props }) => (
  <svg
    data-icon='logout'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <path
      fill='currentColor'
      d='M5 21c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 3 19V5c0-.55.196-1.02.587-1.413A1.926 1.926 0 0 1 5 3h7v2H5v14h7v2H5Zm11-4-1.375-1.45 2.55-2.55H9v-2h8.175l-2.55-2.55L16 7l5 5-5 5Z'
    />
  </svg>
);

Logout.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

Logout.defaultProps = {
  width: 24,
  height: 24,
};
